// This must be a JS file otherwise when it gets compiled it turns into AMD
// syntax which will not work without the right loader.
require('../../bootstrap-amd').load('vs/server/entry');
